/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeownershipConsentChange = {
    Granted: 'granted',
    Withdrawn: 'withdrawn'
} as const;
export type HomeownershipConsentChange = typeof HomeownershipConsentChange[keyof typeof HomeownershipConsentChange];


export function HomeownershipConsentChangeFromJSON(json: any): HomeownershipConsentChange {
    return HomeownershipConsentChangeFromJSONTyped(json, false);
}

export function HomeownershipConsentChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipConsentChange {
    return json as HomeownershipConsentChange;
}

export function HomeownershipConsentChangeToJSON(value?: HomeownershipConsentChange | null): any {
    return value as any;
}

